import { z } from 'zod'

export const schema = z.object({
  badge: z.string(),
  preTitle: z.string().nullish(),
  postTitle: z.string().nullish(),
  title: z.string(),
  text: z.string(),
  buttonText: z.string(),
  redirectUrl: z.string(),
  video: z.object({
    webmLink: z.string(),
    mp4Link: z.string(),
    captionsSrc: z.string(),
    posterImage: z.string()
  })
})
